module.exports = function getResource(label, vars = []) {
    let resources = {
        emailAddresLabel: 'Email address',
        phoneNumber: 'US Phone number',
        signUp: 'Sign up',
        phoneInputErrorMsg: 'Please enter a phone number in the format of XXX-XXX-XXXX',
        successMsg: `Thanks! You’re now signed up${vars[0] ? vars[0] : '.'}`,
        successMsgEmail: ' for emails.',
        successMsgPhone: ' for text alerts.',
        errorMsg: 'Please correct the error(s) in the highlighted fields above. '
    };
    return resources[label];
};
